import { render } from "./UiNumberInput.vue?vue&type=template&id=4f6d4fe9&scoped=true&ts=true"
import script from "./UiNumberInput.vue?vue&type=script&lang=ts"
export * from "./UiNumberInput.vue?vue&type=script&lang=ts"

import "./UiNumberInput.vue?vue&type=style&index=0&id=4f6d4fe9&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f6d4fe9"]])

export default __exports__